import { useSelectedAdfoxBannerConfig } from './useSelectedAdfoxBannerConfig';
import { EBanners } from '../../../constants/banners';

export function useGetAdfoxBanner(): EBanners.Adfox | null {
  const selectedConfig = useSelectedAdfoxBannerConfig();

  return selectedConfig ? EBanners.Adfox : null;
}
